import classNames from 'classnames'

import * as styles from './IconChevron.module.css'

import DownIcon from '../../../icons/chevrons/down.svg'

/**
 * IMPORTANT:
 * This component intentionally does NOT define a default `className`.
 *
 * Icons are often rendered inside other components (e.g. Button, Input, etc.)
 * that inject their own styles via `className`.
 * Adding a default class here would override or conflict with parent styles
 * (e.g. via CSS Modules `composes`).
 *
 * Always pass `className` from the parent component when styling is required.
 */
function IconChevron({
  Icon = DownIcon,
  className,
  direction,
  directionClassNames = styles,
  ref,
  ...iconProps
}) {
  return (
    <Icon
      {...iconProps}
      className={classNames(
        className,
        styles.chevronIcon,
        directionClassNames[direction]
      )}
      ref={ref}
    />
  )
}

export default IconChevron
